/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RansomwareRecoveryEdrVendorEnum } from './ransomwareRecoveryEdrVendorEnum';


export interface RwrDeploymentWithNullEdrRegion { 
    deployment_id?: string;
    edr_vendor?: RansomwareRecoveryEdrVendorEnum;
    edr_org_id?: string;
    activation_state?: string;
}
export namespace RwrDeploymentWithNullEdrRegion {
}


